import { useState, useEffect } from "react";
// material
import { Box, Card, Container, Typography } from "@mui/material";
// components
import Scrollbar from "../table/Scrollbar";
import ListToolbar from "../table/ListToolbar";
import TableView from "../Table";
import { getMonday } from "../../utils/tableFunctions";
import {
  getSDMerchant,
  getSDFilterParam,
  getSDCSV,
} from "../../services/deposit";
import moment from "moment";
import { Log, getNextPage } from "../../services/services";

import { MultiCheckboxesType, MultiSelect } from "../table/Filter";
import CircularLoader from "../circularLoader";

// ----------------------------------------------------------------------

export default function TransactionList() {
  const [transaction, setTransaction] = useState();
  const [next, setNext] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});

  // ------------------ filterStuffies --------------------//
  const [fMerchantName, setFMerchantName] = useState([]);

  const [fDate, setFDate] = useState([getMonday(), moment()]);
  const [fCurrency, setFCurrency] = useState([]);
  const [reset, setReset] = useState(false);
  const filter = {
    merchant_name: fMerchantName,
    currency: fCurrency,
  };

  const filterComponents = () => {
    return (
      fParams &&
      fParams.merchant_name && (
        <Container sx={{ overflowX: "auto" }}>
          <Box sx={{ mt: 3 }}>
            <Box sx={{ height: 15 }} />
            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Merchant Name
            </Typography>
            <MultiSelect
              options={fParams.merchant_name.map((name) => ({
                value: name ? name : "",
                label: name ? name : "",
              }))}
              setSelectedValues={setFMerchantName}
              selectedValues={fMerchantName}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />

            <Typography variant="subtitle1" sx={{ my: 1 }}>
              Currency
            </Typography>
            <MultiCheckboxesType
              items={fParams.currency}
              checkedValues={fCurrency}
              setCheckedValues={setFCurrency}
              reset={reset}
            />
            <Box sx={{ height: 15 }} />
          </Box>
        </Container>
      )
    );
  };

  const onFilterSubmit = () => {
    Log.info('Click button [Apply Filter] - Search Security Deposit list', filter);
    getSDMerchant(setTransaction, null, false, filter);
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const getCSVData = async () => {
    const data = await getSDCSV(filter);
    return data;
  };

  const getNext = async () => {
    if (!next) return;
    const res = await getNextPage({
      url: next,
      filter: filter,
    });
    let newRows = formatData(res);
    setTableData((old) => [...old, ...newRows]);
    setNext(res.next ? res.next : false);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  useEffect(() => {
    if (!loaded) {
      getSDFilterParam(setFParams);
      getSDMerchant(setTransaction, setLoaded, false, filter);
    }
  }, [loaded]);

  const formatData = (input) => {
    let tableData = [];
    input?.results?.forEach(
      ({
        id,
        currency,
        merchant_id,
        merchant_name,
        next_release_amount,
        release_date,
        total,
      }) => {
        tableData.push({
          id: id,
          currency: currency,
          merchant_id: merchant_id,
          merchant_name: merchant_name,
          next_release_amount: next_release_amount,
          release_date: release_date,
          total: total,
        });
      }
    );
    return tableData;
  };

  useEffect(() => {
    if (transaction) {
      setTableData(formatData(transaction));
      setNext(transaction.next);
    }
  }, [transaction]);

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      {loaded ? (
        <Card>
          <ListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            date={fDate}
            filter={true}
            loaded={loaded}
            type="reconciled_transactions"
            filterFunction={filterComponents}
            onFilterSubmit={onFilterSubmit}
            setReset={setReset}
            csv={false}
            getCSVData={transaction.count > 0 ? getCSVData : false}
          />
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/details/deposit`}
              getNext={getNext}
              count={transaction.count}
              query={filterName}
              urlId={["merchant_id", "currency"]}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}
    </Container>
  );
}
